import React from 'react';
import styles from './NotesAndDocuments.module.scss';
import ProgressNotes from './ProgressNotes/ProgressNotes';
import GoalActionPlanDocument from './Documents/GoalActionPlanDocument';
import { useProgressNotesAPI } from '../../CustomHooks/useProgressNotesAPI';
import { useParams } from 'react-router-dom';
import { useDocumentsAPI } from '../../CustomHooks/useDocumentAPI';
import SuccessionPlan from '../PersonalInformation/SuccessionPlan/SuccessionPlan';

interface NotesAndDocumentsProps {}

const NotesAndDocuments: React.FC<NotesAndDocumentsProps> = () => {
  const growthPlanNotesAPI = useProgressNotesAPI('notesAndDocument');
  const successionPlanAPI = useDocumentsAPI('successionPlan');

  return (
    <div className={`NAD_wrapper ${styles.NAD_wrapper}`} data-testid="notesdocument_testID">
      <div className={`content_inner ${styles.NAD_inner_wrapper}`}>
        <div className={styles.section_wrapper}>
          <ProgressNotes api={growthPlanNotesAPI} type="notesAndDocument" />
        </div>
        <div className={styles.section_wrapper}>
          <GoalActionPlanDocument />
        </div>
        <div className={styles.vsection_wrapper}>
          <SuccessionPlan api={successionPlanAPI} />
        </div>
      </div>
    </div>
  );
};

export default NotesAndDocuments;
